const setup = () => {
  const KEY = "cjQ9X62xBGw"

  /* eslint-disable */
  ;(function (c, o, v, i, e, w) {
    c[v] =
      c[v] ||
      function () {
        ;(c[v].a = c[v].a || []).push(arguments)
      }
    var s = o.createElement(i)
    s.src = e
    s.async = 1
    var h = o.getElementsByTagName(i)[0]
    h.parentNode.insertBefore(s, h)
    c.addEventListener("error", function (err) {
      c[v]("error", err)
    })
    c.addEventListener("message", function (msg) {
      c[v]("message", msg)
    })
  })(window, document, "coview", "script", "https://cdn.coview.com/coview.js")
  coview("start", {
    projectKey: KEY
  })
  /* eslint-enable */
}

export default {
  setup
}
